import { createFileRoute, Link } from "@tanstack/react-router";
import { services } from "@/data/services";
import { images } from "@/data/images";
import { Section, SectionHeading } from "@/components/site/Section";
import { CtaBand } from "@/components/site/CtaBand";
import { meta } from "@/lib/schema";
import { overviewKeywords } from "@/lib/localKeywords";

const title = "Verhuisdiensten Zuid-Holland | Vakkundig Verhuizingen & Transport";
const description =
  "Alle verhuisdiensten van Vakkundig in Zuid-Holland: particuliere en zakelijke verhuizing, seniorenverhuizing, inpakservice, verhuislift, ontruiming, opslag en transport. Vraag een gratis offerte aan.";

export const Route = createFileRoute("/diensten/")({
  head: () =>
    meta({
      title,
      description,
      path: "/diensten",
      image: "particulier",
      keywords: overviewKeywords(services.map((s) => s.title.toLowerCase())),
    }),
  component: DienstenIndex,
});

function DienstenIndex() {
  return (
    <>
      <Section tone="navy">
        <SectionHeading
          as="h1"
          eyebrow="Onze diensten"
          title="Verhuizen, opslag en transport door één team"
          intro="Je kiest zelf hoeveel je uit handen geeft. Wij regelen alles van inpakken tot het opbouwen van je meubels in de nieuwe woning."
          inverted
        />
      </Section>

      <Section>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {services.map((service) => (
            <Link
              key={service.slug}
              to="/diensten/$slug"
              params={{ slug: service.slug }}
              className="group overflow-hidden rounded-xl border border-border bg-background shadow-[var(--shadow-card)] transition hover:border-brand"
            >
              <img
                src={images[service.image]}
                alt={`${service.title} door Vakkundig Verhuizingen & Transport`}
                className="h-44 w-full object-cover"
                loading="lazy"
              />
              <div className="p-6">
                <h2 className="font-display text-xl font-bold text-secondary group-hover:text-brand">
                  {service.title}
                </h2>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{service.short}</p>
                <span className="mt-4 inline-block text-sm font-bold text-brand">Meer informatie →</span>
              </div>
            </Link>
          ))}
        </div>
      </Section>

      <CtaBand />
    </>
  );
}
